document.addEventListener('DOMContentLoaded', function () {

    //都道府県の切り替え（タブ切り替え）
    const tabs = document.getElementsByClassName('tab');
    for (let i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener('click', tabSwitch);
    }

    function tabSwitch() {
        document.getElementsByClassName('is-active')[0].classList.remove('is-active');
        this.classList.add('is-active');
        document.getElementsByClassName('is-show')[0].classList.remove('is-show');
        const arrayTabs = Array.prototype.slice.call(tabs);
        const index = arrayTabs.indexOf(this);
        document.getElementsByClassName('panel')[index].classList.add('is-show');
    };

    //各都道府県の企業一覧の切り替え
    const links = document.getElementsByClassName('link');
    for (let j = 0; j < links.length; j++) {
        if (document.getElementsByClassName('is-activeC').length === 0) {
            continue;
        }

        links[j].addEventListener('click', companySwitch);
    }

    function companySwitch(e) {
        e.preventDefault();
        document.getElementsByClassName('is-activeC')[0].classList.remove('is-activeC');
        this.classList.add('is-activeC');
        document.getElementById('alljapan').style.display = 'none';
        document.getElementsByClassName('is-showC')[0].classList.remove('is-showC');
        const arrayLinks = Array.prototype.slice.call(links);
        const index = arrayLinks.indexOf(this);
        document.getElementsByClassName('companies')[index].classList.add('is-showC');
    }
});
